import { useNavigate } from "react-router-dom";

import { useAuth } from "src/providers/AuthProvider";
import { checkPermission } from "src/hooks/useHasPermissions";
import type { PermissionCheck } from "src/types/auth";
import { buildNavGroups } from "./navConfig";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "src/components/ui/command";

interface GlobalSearchProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

/**
 * ⌘K palette. Currently navigates between modules only — searching actual customers,
 * invoices and products needs a backend search endpoint, which does not exist yet
 * (the prototype's search box was non-functional too).
 */
const GlobalSearch = ({ open, onOpenChange }: GlobalSearchProps) => {
	const navigate = useNavigate();
	const { user } = useAuth();
	const permissions = user?.permissions ?? [];
	const groups = buildNavGroups(user);

	const go = (path: string) => {
		onOpenChange(false);
		navigate(path);
	};

	return (
		<CommandDialog open={open} onOpenChange={onOpenChange}>
			<CommandInput placeholder="Search customers, invoices, products..." />
			<CommandList>
				<CommandEmpty>No results found.</CommandEmpty>
				{groups.map((group, groupIndex) => {
					const items = group.items.filter(
						(item) => !item.locked && item.path && checkPermission(item.permission as PermissionCheck, permissions)
					);
					if (items.length === 0) return null;

					return (
						<CommandGroup key={group.label ?? `group-${groupIndex}`} heading={group.label ?? "Overview"}>
							{items.map((item) => {
								const Icon = item.icon;
								return (
									<CommandItem key={item.path} value={item.name} onSelect={() => go(item.path as string)}>
										<Icon className="tw-mr-2 tw-h-4 tw-w-4 tw-text-text-soft" />
										{item.name}
									</CommandItem>
								);
							})}
						</CommandGroup>
					);
				})}
			</CommandList>
		</CommandDialog>
	);
};

export default GlobalSearch;
